import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from '../BaseComponent';
import { LayoutType } from '../../constants/LayoutConstants';
import { GlobalHelper } from '../../utils/GlobalHelper';
import { PopupMenu } from '../../constants/Enums';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { ViewSettingsActions } from '../../actions/ViewSettingsActions';
import { ArticleActions } from '../../actions/ArticleActions';

import room = egr.wcf.room;

interface ToolsSetupProps extends React.Props<ToolsSetup> {
    layoutType: LayoutType;
}

export class ToolsSetup extends BaseComponent<ToolsSetupProps, {}> {
    public render(): JSX.Element {
        return (
            <div className="floorplan-setup">
                <div className="egr-select-option-header">
                    <span>{t('Insert')}</span>
                    <div className="floorplan-setup-close sprite-icon-close" onClick={this.onCloseClick} />
                </div>
                <div style={{ maxHeight: 250, overflow: 'hidden' }}>
                    <div className="scrollbar-wcf">
                        <div className="egr-select-option tools-dimension-line" onClick={this.dimensionLine}>
                            <span>{t('Dimension line')}</span>
                        </div>
                        <div className="egr-select-option tools-text" onClick={this.text}>
                            <span>{t('Text')}</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    protected onCloseClick(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
    }

    protected dimensionLine(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Measure = new room.tool.Measure(GlobalHelper.roomManager);
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    protected text(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        GlobalHelper.roomManager.insertRoomElement('Text');
    }

    protected rectangle(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Area2D = new room.tool.Area2D(GlobalHelper.roomManager, 'Rectangle');
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    protected circle(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Area2D = new room.tool.Area2D(GlobalHelper.roomManager, 'Circle');
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    protected freeform(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Area2D = new room.tool.Area2D(GlobalHelper.roomManager, 'Spline');
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    protected walkways(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Route = new room.tool.Route(GlobalHelper.roomManager);
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }

    protected line(): void {
        VisibilityActions.setPopupMenu(PopupMenu.NONE);
        const tool: room.tool.Area2D = new room.tool.Area2D(GlobalHelper.roomManager, 'Line');
        tool.eventStopped.addListener(() => {
            ViewSettingsActions.setDragMode(false);
            ArticleActions.invalidateArticleList();
        });
        GlobalHelper.coreApp.tools.startTool(tool);
        GlobalHelper.focusCanvas();
        ViewSettingsActions.setDragMode(true);
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/popupmenu/ToolsSetup.tsx